import { axiosClientAdmin } from '@/lib/auth';
import { useInfiniteQuery, useQuery } from '@tanstack/react-query';

export interface CustomerDto {
  id: string;
  name: string;
  hasContracts: boolean;
  accountNumber: number;
  archived: boolean;
}
export interface CustomerQueryResponse {
  rows: CustomerDto[];
  totalRows: number;
}

export const useSearchCustomersQuery = ({ query, enabled }: { query: string; enabled?: boolean }) =>
  useInfiniteQuery({
    queryKey: ['customers', query],
    queryFn: async ({ pageParam }) => {
      const res = await axiosClientAdmin.get<CustomerQueryResponse>(
        `/Customer/search?query=${query}`,
        {
          params: {
            PageNumber: pageParam,
            PageSize: 20,
            SortBy: 'name',
            SortDir: 'Ascending',
            'Filter.Operator': 'And',
            'Filter.Filters[0][field]': 'archived',
            'Filter.Filters[0][action]': 'Eq',
            'Filter.Filters[0][value]': 'false',
            'Filter.FilterGroups[0][operator]': 'Or',
            'Filter.FilterGroups[0][filters][0][field]': 'name',
            'Filter.FilterGroups[0][filters][0][value]': query,
            'Filter.FilterGroups[0][filters][0][action]': 'ILike',
          },
        }
      );
      return res.data.rows;
    },
    getNextPageParam: (lastPage, allPages) => {
      if (lastPage.length < 20) {
        return null;
      }
      return allPages.length + 1;
    },
    initialPageParam: 1,
    enabled,
  });

export interface FetchCustomerQueryResponse {
  customer: CustomerDto;
  totalRows: number;
}

export const useFetchCustomerQuery = ({ customerID }: { customerID: string }) =>
  useQuery({
    queryKey: ['customer', customerID],
    queryFn: async () => {
      const res = await axiosClientAdmin.get<FetchCustomerQueryResponse>(`/Customer/${customerID}`);
      return res.data.customer;
    },
  });
